import React, {useState} from "../../__snowpack__/pkg/react.js";
import styled from "../../__snowpack__/pkg/styled-components.js";
import {useScrollPosition} from "../../__snowpack__/pkg/@n8tb1t/use-scroll-position.js";
import {Button} from "../../__snowpack__/pkg/antd.js";
const defaultMinScrollY = -150;
export const ScrollTopButton = (props) => {
  const curMinScrollY = props.minScrollY || defaultMinScrollY;
  const [visible, setVisible] = useState(false);
  useScrollPosition(({prevPos, currPos}) => {
    if (currPos.y < curMinScrollY) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, visible && /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(Button, {
    onClick: () => {
      window.scrollTo({top: 0, behavior: "smooth"});
    },
    className: "scroll-top-button",
    shape: "circle",
    type: "primary",
    icon: /* @__PURE__ */ React.createElement("svg", {
      className: "icon-back-to-top",
      viewBox: "0 0 22 22",
      width: "22",
      height: "22",
      xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ React.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /* @__PURE__ */ React.createElement("path", {
      d: "M0 0h22v22H0z"
    }), /* @__PURE__ */ React.createElement("path", {
      d: "M10.584 7.159a.624.624 0 0 1 .832 0l5.82 5.366c.46.424.304.767-.346.767h-3.534v5.624c0 .599-.527 1.084-1.178 1.084H9.822c-.65 0-1.178-.485-1.178-1.084v-5.624H5.11c-.65 0-.805-.344-.345-.767l5.819-5.366zM17.857 4H4.143C3.512 4 3 3.552 3 3s.512-1 1.143-1h13.714C18.488 2 19 2.448 19 3s-.512 1-1.143 1z",
      fill: "#FFF",
      fillRule: "nonzero"
    })))
  })));
};
const Wrapper = styled.div`
  position: fixed;
  z-index: 100;
  right: 40px;
  bottom: 124px;
  .scroll-top-button {
    width: 40px;
    height: 40px;
    background: #6020ff;
    opacity: 0.6;
    box-shadow: 0px 4px 8px 0px rgba(96, 32, 255, 0.36);
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      opacity: 1;
    }
  }
  .icon-back-to-top {
    width: 16px;
    height: 18px;
  }
`;
